import { type FC, type ReactNode, forwardRef } from "react";
import { NavLink } from "react-router";

export const PageThumbnailList: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="m-4 flex flex-col gap-4">{children}</div>
);

export const PageThumbnail = forwardRef<
  HTMLAnchorElement,
  {
    to: string;
    children: ReactNode;
  }
>(({ to, children }, ref) => (
  <NavLink
    ref={ref}
    to={to}
    className="flex cursor-pointer flex-col items-center gap-2 p-2"
  >
    {children}
  </NavLink>
));

PageThumbnail.displayName = "PageThumbnail";
